import {getUserIDState, callAPI, handleAlert} from './sagaHelper';

import {
  ADD_CYCLE_ACTIVITY,
  DIGIDIARY_SET_LOADER,
  DIGIDIARY_GET_FARM_DATA,
} from '../actions';

import {takeEvery, select, put, call} from 'redux-saga/effects';

export function* addCycleActivity({data}) {
  let flag = true;
  yield put({type: DIGIDIARY_SET_LOADER, flag});
  let userId = yield select(getUserIDState);
  const response = yield call(callAPI, {
    method: 'put',
    url: `/farmDetails?customerId=${userId}`,
    data: data,
  });

  flag = false;
  yield put({type: DIGIDIARY_SET_LOADER, flag});

  if (response.statusCode && response.statusCode === 200) {
    yield put({type: DIGIDIARY_GET_FARM_DATA});
  } else {
    yield call(handleAlert, {
      variant: 'error',
      type: 'alertError',
    });
  }
}
export function* addCycleActivityDataSaga() {
  yield takeEvery(ADD_CYCLE_ACTIVITY, addCycleActivity);
}
